// extracted by mini-css-extract-plugin
export default {"mainNav":"Header_mainNav__XRWyv","logo":"Header_logo__Jme91","versionNumber":"Header_versionNumber__g9ZOP","iconLink":"Header_iconLink__HXQIB"};